import { Hash, LetterText, Palette, Plus, ToggleRight } from "lucide-react"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import { useState } from "react"
import { styled } from "@mui/material"
import { Parameter } from "../../shared/Parameter"

type Props = {
  onAddParameter: (type: Parameter["type"]) => void
}
export function AddParameterChipButton2({ onAddParameter }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  function handleAddParameterClick(type: Parameter["type"]) {
    setAnchorEl(null)
    onAddParameter(type)
  }
  const open = Boolean(anchorEl)
  return (
    <>
      <_ParameterChipButton onClick={handleClick}>
        <Plus size={18} />
        Add Parameter
      </_ParameterChipButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleAddParameterClick("color")}>
          <ListItemIcon>
            <Palette size={18} />
          </ListItemIcon>
          <ListItemText>Color</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleAddParameterClick("number")}>
          <ListItemIcon>
            <Hash size={18} />
          </ListItemIcon>
          <ListItemText>Number</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleAddParameterClick("boolean")}>
          <ListItemIcon>
            <ToggleRight size={18} />
          </ListItemIcon>
          <ListItemText>Boolean</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleAddParameterClick("string")}>
          <ListItemIcon>
            <LetterText size={18} />
          </ListItemIcon>
          <ListItemText>Text</ListItemText>
        </MenuItem>
      </Menu>
    </>
  )
}

const _ParameterChipButton = styled("button")({
  display: "inline-flex",
  gap: 6,
  alignItems: "center",
  padding: "4px 8px 4px 8px",
  borderRadius: 999,
  background: "rgb(230, 230, 230)",
  border: "1px solid rgb(210, 210, 210)",
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 1,
  "&:hover": {
    background: "rgb(240, 240, 240)",
  },
})
